import React from 'react';
import InputError from './InputError';
import InputLabel from './InputLabel';

const InputSelectGroup = ({
  label,
  id,
  name,
  required,
  options = [],
  error,
  onChange,
  defaultValue,
}) => {
  return (
    <div className="flex flex-col py-2">
      <InputLabel title={label} />
      <select
        className="my-1 rounded-primary border-width-mini border-grey-200 bg-white py-3 px-2 text-base placeholder:text-sm focus:outline-none"
        id={id}
        name={name}
        required={required}
        onChange={onChange}
        defaultValue={defaultValue}
      >
        {options.map((option, index) => {
          return (
            <option value={option.id} key={option + index}>
              {option.title}
            </option>
          );
        })}
      </select>
      <InputError id={id} error={error} />
    </div>
  );
};

export default InputSelectGroup;
